import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Ai = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.667 2.227a.358.358 0 0 1 .666 0l.916 2.322a.36.36 0 0 0 .202.202l2.322.916a.358.358 0 0 1 0 .666l-2.322.916a.36.36 0 0 0-.202.202l-.916 2.322a.358.358 0 0 1-.666 0l-.916-2.322a.36.36 0 0 0-.202-.202l-2.322-.916a.358.358 0 0 1 0-.666l2.322-.916a.36.36 0 0 0 .202-.202zM9.583 8.396a.626.626 0 0 0-1.166 0l-1.603 4.065a.63.63 0 0 1-.353.354l-4.065 1.602a.626.626 0 0 0 0 1.166l4.065 1.603a.63.63 0 0 1 .353.354l1.603 4.064a.626.626 0 0 0 1.166 0l1.602-4.065a.63.63 0 0 1 .354-.354l4.065-1.602a.626.626 0 0 0 0-1.166l-4.065-1.602a.63.63 0 0 1-.354-.354z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Ai) as SvgIcon;
export { ForwardRef as ReactComponent };
